import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/FontAwesome5/unicodesMap.json';
export default createIconSet(glyphMap, 'FontAwesome5', require('~/../assets/fonts/FontAwesome5/FontAwesome5.ttf'));
